import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { CurrentTimeDisplay } from './current-time-display'

@register
export class VodCurrentTimeDisplay extends CurrentTimeDisplay {
  override updateBoundaries(boundaries: Events.Media.ProgressBarChanged) {
    if (boundaries === undefined) {
      this.enable()
    }
  }

  @on(Events.Media.TimeUpdate)
  handleTimeUpdate(currentTime: number) {
    if (this.enabled_) {
      this.updateForced(currentTime)
    }
  }

  @on(Events.Media.ContentChanged)
  contentChanged() {
    this.enable()
  }

  @on(['seeking', 'seeked'])
  handleSeeking() {
    if (this.player_.paused()) {
      this.updateForced(this.player_.currentTime())
    }
  }

  override update(currentTime: number) {
    // ignore updates while the tab is hidden
    // TODO: add listener for visibility change -> this.on(document, 'visibilitychange', this.toggleVisibility_)
    if (document.visibilityState === 'hidden') return

    const duration = this.player_.duration()

    const timeToEndMs = (duration - currentTime) * 1000

    this.setTime(timeToEndMs)
  }
}

VodCurrentTimeDisplay.options = {
  className: 'vjs-x-current-time-display vjs-x-vod-current-time-display',
}
